// extracted by mini-css-extract-plugin
module.exports = {"action-points-container":"styles-module__action-points-container___vS8mH"};